<template>
    <footer class="footer">
      <div class="footerLink">
        会社手続きナビゲーター モチカケ
      </div>
    </footer>
  </template>
  
  <script>
  export default {
    name: 'f-footer-lp-minimal'
  }
  </script>
  